import React, { Component } from 'react';
import _ from 'lib/lodash'

import Button from 'react-md/lib/Buttons'
import ListItem from 'react-md/lib/Lists/ListItem'
import Divider from 'react-md/lib/Dividers'
import SelectionControlGroup from 'react-md/lib/SelectionControls/SelectionControlGroup';
import Checkbox from 'react-md/lib/SelectionControls/Checkbox';

import LoadingSpinnerSmall from 'components/common/LoadingSpinnerSmall'

import './FeedbackCardTemplate.css'

class FeedbackCardTemplate extends Component {

	componentDidMount() {
		const { title } = this.props.node.properties;

		if (!title) this.props.onEdit(); // Make sure drawer is shown for empty element
	}

	render() {
		const { node, actionHandler } = this.props;
		const { nodeHandler } = actionHandler;
		const { title, inputType, items } = node.properties;

		const isDeleting = nodeHandler.isDeleting && nodeHandler.currentNode.$id === node.$id;

		const renderTitle = () => title || "Neues Feedback-Element";

		const renderMenu = () => <Button icon onClick={this.props.onEdit}>edit</Button>;

		const renderChoices = () => {
			switch (inputType) {
				case "radio":
					return <SelectionControlGroup
						id={`feedback-radio-inputx-${node.$id}`}
						name={`feedback-radio-inputx-${node.$id}`}
						type="radio"
						controls={items}
						value=""
						disabled
					/>;

				case "checkbox":
					return <div>
						{ _.map(items, ({label, value}) =>
							<Checkbox
								id={`feedback-checkbox-input-${node.$id}`}
								name={`feedback-checkbox-input-${node.$id}`}
								key={value}
								label={label}
								value=""
								disabled
							/>
						) }
					</div>;

				default:
					return null
			}
		};

		const renderContent = () => (
			<div className="feedback-card-item" id={node.$id}>
				<ListItem
					primaryText={renderTitle()}
					secondaryText={renderChoices()}
					rightIcon={renderMenu()}
					disabled
				/>
			</div>
		);

		const renderIsDeleting = () => <LoadingSpinnerSmall message="Frage wird gelöscht..." />;

		return (
			<div className="feedback-card-item-container">
				{!isDeleting ? renderContent() : renderIsDeleting()}
				<Divider className="feedback-card-item-divider"/>
			</div>
		)
	}

}

export default FeedbackCardTemplate;


// WEBPACK FOOTER //
// ./src/components/cards/feedback/default/FeedbackCardTemplate.jsx